function getMaxWidth() {
  var widths = [];
  $("#main-product-detail .product-page-vt .v-input-wrapper label").map(function (i,item) {
   widths.push($(item).width())
 })
 var maxWidth = Math.max(...widths) + 20;
 $("#main-product-detail .product-page-vt .v-input-wrapper label").css("width", maxWidth);
}
function updatePrice(){
  fetch('/cart.js')
  .then(response => response.json())
  .then(data => {
    $(".mh-cart-price,.checkout-col .subtotal").html(Shopify.formatMoney(data.total_price, theme.money_format));
  });
}
function getCarts() {
  var carts = {};
  var products = {}
  var boxs = []
  cartObj.items.forEach((item, i) => {
    console.log(item.product_id);
    carts[item.product_id] = {
      [item.id]: {
        id: item.id,
        quantity: item.quantity,
        key: item.key,
        price: item.line_price,
        title: item.variant_options.length > 1 ? item.variant_options[1] : item.variant_options[0]
      },
      ...carts[item.product_id]
    };
    products[item.product_id] = {
      title: item.product_title,
      id: item.product_id,
      image: item.image,
      url: item.url
    }

  });
  for (const property in products) {
    console.log(`${property}: ${products[property]}`);
    boxs.push({
      ...products[property],
      variants: Object.values(carts[property])
    })
  }
  return boxs;
}
var app = new Vue({
  el: "#cart-app",
  delimiters: ["${", "}"],
  data: {
    boxs: getCarts(),
  },
  computed: {

  },
  methods: {
    getMediumImg: function(img) {
      var ext = img.split(".").pop();
      return img.replace("." + ext, "_grande." + ext);
    },
    update(id){
      var ref = $("#"+id).val();
      var variant = {};
      variant[id] = ref;
      console.log(variant);

      this.updateVariant(variant)
    },
    remove(variants){
      var variant = {};
      variants.forEach(function(v){
        variant[v.id] = 0;
      });
      console.log(variant);
      this.updateVariant(variant, true);

    },
    updateVariant(variant, redirect = false ){
      axios
      .post("/cart/update.js", { updates: variant })
      .then(function (response) {
        console.log(response);
        console.log("update / removed the variant");
        updatePrice();
        if (redirect) {
          window.location = "/cart";
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    formatMoney: function(variants) {
      var price = 0;
      variants.forEach(function(v){
          price+= v.price
      })
      return Shopify.formatMoney(price, theme.money_format);
    }
  },
  mounted() {

  }
});
$(function() {
  console.log("work");
  getMaxWidth();
  var ref = "";
  var errorRef = "";
  async function addVariants(items) {
    let formData = {
      items,
    };
    console.log(formData.items);
    await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
      .then((response) => {
        return response.json();
      })
      .then(async (data) => {
        console.log(data);
        errors(data.description)
        ref.val('Thank you');
        checkout();
      })
      .catch((error) => {
        console.error("Error:", error);
        errors(error.description)
        checkout();
      });
  }

  function errors(msg) {
    console.log(msg);
    if (!msg) {
      return false;
    }
    $(errorRef).fadeIn();
    $(errorRef).html(msg);
    setTimeout(function() {
      $(errorRef).fadeOut();
      $(errorRef).html();
    }, 2500);
  }

  function checkout() {
    updatePrice();
    setTimeout(function() {
      ref.val('Add to Cart');
      ref.prop("disabled", false);
    }, 400);
    // $(".checkout-form").submit();
  }
  $(".input-wrapper input").on('click', function(event) {
    event.preventDefault();
    ref = $(this);
    ref.val('Adding...');
    ref.prop("disabled", true);
    var target = $(ref).data("target");
    errorRef = $(ref).data("error");
    var items = []
    $(target).map((i, el) => {
      var id = $(el).data("available")
      var quantity = Number($(el).val());
      if (id && quantity) {
        items.push({
          id: Number(id),
          quantity: quantity,
        });
      }
    });
    console.log(items);
    addVariants(items);
  });


})
